import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "content", "icon"]

  connect() {
    // Initialize all items as collapsed
    this.contentTargets.forEach(content => {
      content.style.maxHeight = "0"
    })
  }

  toggle(event) {
    const index = event.params.index
    const content = this.contentTargets[index]
    const icon = this.iconTargets[index]
    const button = event.currentTarget
    const isExpanded = button.getAttribute("aria-expanded") === "true"

    if (isExpanded) {
      // Collapse
      content.style.maxHeight = "0"
      icon.classList.remove("rotate-45")
      button.setAttribute("aria-expanded", "false")
    } else {
      // Expand
      content.style.maxHeight = content.scrollHeight + "px"
      icon.classList.add("rotate-45")
      button.setAttribute("aria-expanded", "true")
    }
  }
}
